import { createRoute, Outlet, redirect } from "@tanstack/solid-router";
import { isAdminCapable } from "@vigia/shared";
import { appRoute } from "./route";
import { sessionActor } from "@/lib/session-machine";
import { readAccountsStateSync } from "@/lib/accounts";
import { resolveActiveAccountView } from "@/lib/active-account";
import { readTabAccountId } from "@/lib/tab-account";

export const adminRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/admin",
  beforeLoad: () => {
    const tabAccountId = readTabAccountId();
    const view = resolveActiveAccountView(
      readAccountsStateSync(),
      tabAccountId,
      sessionActor.getSnapshot().context.session,
    );

    if (!isAdminCapable(view.role)) {
      throw redirect({ to: "/profile" });
    }
  },
  component: () => <Outlet />,
});
